import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import SurveyRow from './SurveyRow';
import SurveyStatistics from './SurveyStatistics';
import SimpleSelect from './SimpleSelect'
import {orderBy } from '../common/orderby'
import {getError } from '../common/getError'
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css'
import moment from 'moment';
import 'moment/locale/de'
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import SaveIcon from '@material-ui/icons/Save';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import CircularProgress from '@material-ui/core/CircularProgress';
import queryString from 'query-string';
import LinearProgress from '@material-ui/core/LinearProgress';
import Awesome1Img from '../../images/awesome.gif'
import Avatar from '@material-ui/core/Avatar';
import { Dialog, Checkbox, Input } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import arrowLeft from '../../images/arrow-left.png'
import arrowRight from '../../images/arrow-right.png'
import { Link } from 'react-router-dom'

import { format } from 'react-string-format';

import AceEditor from 'react-ace';
import brace from 'brace';

import 'brace/mode/json';
import 'brace/ext/searchbox'
import 'brace/theme/monokai';


export class DefaultPage extends Component {
  static propTypes = {
    workerConfig: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = 
  {
    avatarLarge: false,
    tourTooltipOpen: false
  }

  handleTourTooltipToggle()
  {
    this.setState({tourTooltipOpen: !this.state.tourTooltipOpen});

  }

  handleTourTooltipClose()
  {
    this.setState({tourTooltipOpen: false});

  }

  onChangeGenericWorkerCost(evt)
  {
    let lastResult = {};
    try {
        lastResult = JSON.parse(evt);
        this.props.actions.setGenericWorkerCostDefinition(lastResult);
    } catch(e) {
        console.log(e);
    }
    this.setState({configText: evt});
    
    
  }

  fetchData()
  {
    console.log("fetchData " + !this.props.workerConfig.loggedInUser);

    if (!this.props.workerConfig.webClientConfig) {
      if (!this.props.workerConfig.fetchConfigPending && !this.props.workerConfig.fetchConfigError)
      this.props.actions.fetchConfig();
    }

    if (!this.props.workerConfig.loggedInUser) {
      console.log("no logged in user")

      let params = queryString.parse(this.props.location.search);
      let code = params.code;  
      //console.log({params});
      //console.log("code = " + code);
      if (code && !(this.props.workerConfig.triedCodes && this.props.workerConfig.triedCodes[code]))
      {
        if (!this.props.workerConfig.loginPending && !this.props.workerConfig.loginError)
          this.props.actions.login(code, this.getRedirectUri());
      }
      else {
        if (!this.props.workerConfig.fetchLoggedInUserPending && !this.props.workerConfig.fetchLoggedInUserError)
        {
          console.log("fetchLoggedIn");
          this.props.actions.fetchLoggedInUser();
        }
      }
      
    }
    else if (!this.props.workerConfig.seasons) {
      console.log("no seasons");
      if (!this.props.workerConfig.fetchWorkerDataPending && (!this.props.workerConfig.fetchWorkerDataError))
      {
        console.log("fetch data ");
        console.log({error: this.props.workerConfig.fetchWorkerDataError});
        let id = parseInt(this.props.match.params.id,10) || this.props.workerConfig.loggedInUser.id;
      this.props.actions.fetchWorkerData({workerId: id, fetchProperties: this.props.workerConfig.loggedInUser.isAdmin});
      }
    }
    else
    {
      let id = parseInt(this.props.match.params.id,10) || this.props.workerConfig.loggedInUser.id;
      if (!this.props.workerConfig.displayedUser || this.props.workerConfig.displayedUser.id !== id)
      {
        if (id)
        {
          window.scroll(0,0)
          this.props.actions.setDisplayedUser(id);
        }
      }
    }
    
  }
  
  componentDidMount() {
    this.fetchData();
  }

  
  componentDidUpdate() {
    this.fetchData(); 

  }

  getNewId(obj)
  {
    let id = 1;
    while (obj[id]) id++;
    return id;
  }

  findAvailability(date_and_restriction)
  {
    let matchingWdas = Object.values(this.props.workerConfig.workerDateAvailabilities).filter(wda => (wda.dateRestriction === date_and_restriction.dateRestriction) && (wda.date === date_and_restriction.date) && (wda.workerId === this.props.workerConfig.displayedUser.id));
    if (matchingWdas.length === 0)
      return undefined;
    return matchingWdas[0].availability;
  }

  setNewDateAvailability(newData)
  {
    let {date, dateRestriction, availability} = newData;
    let matchingWdas = Object.values(this.props.workerConfig.workerDateAvailabilities).filter(wda =>  (wda.dateRestriction === dateRestriction) && (wda.date === date) && (wda.workerId === this.props.workerConfig.displayedUser.id));
    let modifiedWda = {};
    if (matchingWdas.length === 0)
      {
        let newId = this.getNewId(this.props.workerConfig.workerDateAvailabilities);
        modifiedWda = {
          id: newId,
          date: date, 
          dateRestriction: dateRestriction,
          workerId: this.props.workerConfig.displayedUser.id,
          availability: availability,
          dirty: true,
          wasCreated: true
        };

      }
      else
      {
        modifiedWda = {...matchingWdas[0],
          availability: availability,
          dirty: true
        };
      }
    this.props.actions.updateLocalDateAvailability(modifiedWda);

  }

  setNewLocationAvailability(newData, wla)
  {
    this.props.actions.updateLocalLocationAvailability({...wla, availability: newData.availability, dirty: true});
  }

  setNewRoleAvailability(newData, wra)
  {
    this.props.actions.updateLocalRoleAvailability({...wra, availability: newData.availability, dirty: true});
  }

  setNewFrequencyRange(waf, newValue)
  {
    this.props.actions.updateLocalWorkerAvailabilityFrequency({...waf, minNumAvailableDays: newValue.min, maxNumAvailableDays: newValue.max, dirty: true});


  }

  setNewLocationFrequencyRange(wlf, newValue)
  {
    this.props.actions.updateLocalWorkerLocationFrequency({...wlf, minNumPerSeason: newValue.min, maxNumPerSeason: newValue.max, dirty: true});
  }
  
  setNewRoleFrequencyRange(wlf, newValue)
  {
    this.props.actions.updateLocalWorkerRoleFrequency({...wlf, minNumPerSeason: newValue.min, maxNumPerSeason: newValue.max, dirty: true});
  }

  setConsecutiveAvailability(newData, waf)
  {
    this.props.actions.updateLocalWorkerAvailabilityFrequency({...waf, consecutiveAvailability: newData.availability, dirty: true});
  }

  setOnceTooOftenAvailability(newData, waf)
  {
    this.props.actions.updateLocalWorkerAvailabilityFrequency({...waf, onceTooOftenAvailability: newData.availability, dirty: true});
  }

  setWorkerPartner(newPartnerId, currentUserId, invert, weight)
  {
    let workerPairs = this.props.workerConfig && currentUserId && this.props.workerConfig.workerPairs && Object.values(this.props.workerConfig.workerPairs).filter(wp => wp.workerId === currentUserId);
    let newWp = {};
    if (workerPairs[0])
    {
      newWp = {...workerPairs[0], worker2Id: newPartnerId || -1, invert, weight, dirty: true};
    }
    else
    {
      newWp = {id: this.getNewId(this.props.workerConfig.workerPairs), wasCreated: true, workerId: currentUserId, worker2Id: newPartnerId || -1, invert, weight, dirty: true};
    }
    this.props.actions.updateLocalWorkerPair(newWp);
    
  }
  
  getRedirectUri(surveyPageUrl)
  {
    if (surveyPageUrl)
      return surveyPageUrl;
    let my_uri = window.location.href;
    if (my_uri.indexOf("?") > 0) 
      my_uri = my_uri.substring(0, my_uri.indexOf("?"));
    return my_uri;
  }

  getPropertyExperience(prop)
  {
    let wps = Object.values(this.props.workerConfig.workerProperties).filter(wp => wp.key === prop.name);
    if (wps.length === 1)
    {
      let wp = wps[0];
      let pseudoAvailability = 0;
      if (wp.value == 0)
        pseudoAvailability = undefined;
      else if (wp.value <= 10)
        pseudoAvailability = 3;
      else if (wp.value <= 20)
        pseudoAvailability = 2;
      else if (wp.value <= 40)
        pseudoAvailability = 1;
      return {
        ...wp,
        availability: pseudoAvailability
      }
    }
    return {
      key: prop.name
    }
    
  }
  setNewWorkerProperty(data)
  {
    let value = 0;
    if (data.availability === 0)
      value = 1000;
    else if (data.availability === 1)
      value = 40;
    else if (data.availability === 2)
      value = 20;
      else if (data.availability === 3)
      value = 10;

    if (data.id !== undefined)
    {
      let modifiedProp = {...this.props.workerConfig.workerProperties[data.id],
        value,
        dirty: true
      };
      this.props.actions.updateLocalWorkerProperty(modifiedProp);

    }
    else
    {
      data.id = this.getNewId(this.props.workerConfig.workerProperties);
      
      let newProp = {
        wasCreated: true,
        dirty: true,
        id: data.id,
        key: data.what,
        workerId: this.props.workerConfig.displayedUser.id,
        value
      };
      this.props.actions.updateLocalWorkerProperty(newProp);      

    }
   
  }

  render() {
    if (this.props.workerConfig.displayedUser && this.props.workerConfig.displayedUser.id && !this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id])
    {
      console.log({wc: this.props.workerConfig});
      return <div>Unknown user id</div>;
    }

    let params = queryString.parse(this.props.location.search);

    let is_admin = this.props.workerConfig.loggedInUser && this.props.workerConfig.loggedInUser.isAdmin; 

    moment.locale('de')    
    let currentUserId = undefined;
    let currentSeason = undefined;
    let datesOfSeason = undefined;

    let nextWorkerId = undefined;
    let previousWorkerId = undefined;

   

    let date_and_restriction_by_key = {};

    let waf = undefined;
    let minFreeDates = 0;
    let maxBlockedDates = 100;
    let numByAvailability = {};
    let numBlocked = 0;
    let numTotal = 0;
    let goodRatio = 0.8;
    let numGood = 0;
    let minAssignedDates = 0;

    currentSeason = this.props.workerConfig.seasons &&
      orderBy( Object.values(this.props.workerConfig.seasons).filter(s => is_admin || s.openForSurvey), s => s.from).slice(-1)[0];

    let locationAvailabilities = [];

    if (currentSeason &&this.props.workerConfig.loggedInUser && this.props.workerConfig.displayedUser)
    {
      currentUserId = this.props.workerConfig.displayedUser.id;
      

      if (this.props.workerConfig.workers && this.props.workerConfig.loggedInUser && this.props.workerConfig.loggedInUser.isAdmin)
      {
        
        let orderedWorkers = orderBy(Object.values(this.props.workerConfig.workers).filter(w => w.status), w => [w.status.toUpperCase(), w.name]).map(w => w.id);
        let currentIndex = orderedWorkers.indexOf(currentUserId);
        if (currentIndex > 0)
        {
          previousWorkerId = orderedWorkers[currentIndex-1];
        }
        if (currentIndex < orderedWorkers.length-1)
        {
          nextWorkerId = orderedWorkers[currentIndex+1];
        }
      }

      locationAvailabilities = Object.values(this.props.workerConfig.workerLocationAvailabilities).filter(wla => wla.workerId === currentUserId)      

      Object.values(this.props.workerConfig.plans).filter(p => p.date >= currentSeason.from && p.date <= currentSeason.to
        &&
        ( (p.teamRequired &&  locationAvailabilities.some(l => l.location === p.location) )
         || (p.tourOption > 0 /*0=never*/ && locationAvailabilities.some(l => l.location === "Tour"))))
      .forEach(p =>
        {
          let key = p.date+" " + p.dateRestriction;
           date_and_restriction_by_key[key] = {date: p.date, dateRestriction: p.dateRestriction};
        });

        console.log({date_and_restriction_by_key});

      datesOfSeason = orderBy([...new Set(Object.values(date_and_restriction_by_key).map(dar => dar.date))],d=>d);
      waf = Object.values(this.props.workerConfig.workerAvailabilityFrequencies).filter(waf => waf.workerId === currentUserId)[0];        
      if (waf === undefined)
      {
        waf = {minNumAvailableDays: 0, maxNumAvailableDays: 0, workerId: currentUserId,consecutiveAvailability:2, onceTooOftenAvailability:2}
      }
      let seasonDays = moment.utc(currentSeason.to).diff(moment.utc(currentSeason.from), 'days');
      minAssignedDates = seasonDays/7/4;
       minFreeDates = minAssignedDates*1.5;
       maxBlockedDates = Object.keys(date_and_restriction_by_key).length - minFreeDates;
    
       for (let i=-1;i<=3;i++)
       {
         numByAvailability[i] = 0;
       }
    
    Object.values(date_and_restriction_by_key).forEach(dar =>
      {
        let av = this.findAvailability(dar);
        if (av === undefined)
          av = -1;
        numByAvailability[av]++;
        numTotal++;
  
      });

      numBlocked = numByAvailability[0];
      if (numByAvailability[1] > 1)
        numBlocked += numByAvailability[1]-1; //assume we can schedule on one exceptional date

      numGood = numTotal - (numBlocked+numByAvailability[-1]);

    }

    console.log({loggedInUser:this.props.workerConfig.loggedInUser, displaydUser: this.props.workerConfig.displayedUser, 
      numBlocked, maxBlockedDates, ratio: numGood /numTotal, goodRatio, numTotal,numNotDefined : numByAvailability[-1]}, minAssignedDates);

    let workerPairs = this.props.workerConfig && currentUserId && this.props.workerConfig.workerPairs && Object.values(this.props.workerConfig.workerPairs).filter(wp => wp.workerId === currentUserId);

    /*this.props.workerConfig && this.props.workerConfig.webClientConfig && */
        

    let my_uri = this.getRedirectUri(this.props.workerConfig.webClientConfig && this.props.workerConfig.webClientConfig.redirectUri);
    return (
      <div>
      <div>
<nav class="navbar navbar-expand-lg navbar-light bg-light shadow fixed-top sticky-nav">
  <div class="container">
    <a class="navbar-brand" href="#">{ (this.props.workerConfig.webClientConfig&&this.props.workerConfig.webClientConfig.surveyPageTitle)}</a>
    
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link" href="#survey">Umfrage
                
              </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#settings">Einstellungen
                
              </a>
        </li>
        {
          is_admin ? 
          <li class="nav-item">
          <a class="nav-link" href="/scheduling">Planung</a>
        </li>
        :
        <li class="nav-item">
          <a class="nav-link" href="#about">Wie wird geplant?</a>
        </li>
        }
        
        {this.props.workerConfig.loggedInUser && this.props.workerConfig.loggedInUser.id
        &&
        <li class="nav-item">
          <a class="nav-link" href="#" onClick={() => {this.props.actions.logout()}}>Logout</a>
        </li>
        }
        
      </ul>
    </div>
  </div>
</nav>




<header class="masthead" style={{paddingTop:"2%"}}>
  <div class="headerimg"></div>  
  <div class="container h-100">
    
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
       { this.props.workerConfig.seasons && this.props.workerConfig.displayedUser && this.props.workerConfig.displayedUser.id && this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id]?<div>
        <h1 class="font-weight-light">Terminumfrage für {this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].name}</h1>

      
        
        <p class="lead">
        {previousWorkerId && <Link to={"/worker-config/"+previousWorkerId}><img src={arrowLeft} className="app-logo" alt="previous" /></Link>}
        
          <Button onClick={() => {this.setState({avatarLarge: true})}}><Avatar alt={this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].name} src={this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].avatarThumbUrl} component="div" style={{width: "80px", height: "80px", margin: "0 auto"}}/></Button>
          {nextWorkerId && <Link to={"/worker-config/"+nextWorkerId}><img src={arrowRight} className="app-logo" alt="next" /></Link>}
          
          </p>
        <p class="lead">Bitte sag uns, wann du kannst</p>
        </div>
        : this.props.workerConfig.loggedInUser && this.props.workerConfig.loggedInUser.id ? <h1 class="font-weight-light">Lade...</h1>
          : <div><h1 class="font-weight-light">Terminumfrage</h1><p class="lead" /></div>
       }
        
      </div>
    </div>
  </div>
</header>

{
  (this.props.workerConfig.fetchLoggedInUserPending ||
  this.props.workerConfig.loginPending ||
  this.props.workerConfig.fetchWorkerDataPending ||
  this.props.workerConfig.saveChangesPending ||
  this.props.workerConfig.logoutPending) 
  &&
  <LinearProgress /> 
}

{
this.props.workerConfig.webClientConfig
&&
<div>


{(!this.props.workerConfig.loggedInUser || !this.props.workerConfig.loggedInUser.id)
  && !this.props.workerConfig.fetchLoggedInUserPending
  && !this.props.workerConfig.loginPending
  && <div style={{padding: "1rem"}}>
    <h5>Nicht eingeloggt</h5>
    <p>{this.props.workerConfig.webClientConfig.oauthExplanation}</p>
    <a href={format(this.props.workerConfig.webClientConfig.oauthUrl,my_uri)} class="btn btn-primary btn-lg active" role="button" aria-pressed="true">{this.props.workerConfig.webClientConfig.continueToOauth}</a>
  </div>

}

{ (this.props.workerConfig.loggedInUser && this.props.workerConfig.seasons && !currentSeason)
  &&
  <div  tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Keine Umfrage offen</h5>
        
      </div>
      <div class="modal-body">
        <p>Momentan steht keine Teamplanung an. Bitte schau wann anders wieder vorbei.
        </p>
      </div>
      <div class="modal-footer">
      </div>
    </div>
  </div>
</div>
}


{
  this.state.avatarLarge
  && 
  <Dialog
  open={this.state.avatarLarge}
    onClose={() => this.setState({avatarLarge: false})}
  maxWidth={false}
  >
    <DialogContent>
      <img alt={this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].name} src={this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].avatarUrl} />
      </DialogContent>

  </Dialog>

}

{currentSeason &&this.props.workerConfig.loggedInUser  && this.props.workerConfig.displayedUser &&
<div>


<section class="py-5">
  <div class="container">
  <a name="survey"><h2 class="font-weight-light">Nächster Planungs-Zeitraum</h2></a>
   <table  class="table autowidth">
    <thead style={{minWidth:"500px"}}>
    <tr>
        <th class="shorty"><span>Termin</span></th>
        <th class="shorty"><span>Passt</span></th>
        <th class="shorty"><span>Nicht so gern</span></th>
        <th class="shorty"><span>Nur im Notfall</span></th>
        <th class="shorty"><span>Geht nicht</span></th>        
    </tr>
    </thead>
    <tbody>
    { orderBy(Object.values(date_and_restriction_by_key), dar => dar.date).map(dar => 
    <SurveyRow onChange={(newData) => this.setNewDateAvailability(newData)} data={{date: dar.date, dateRestriction: dar.dateRestriction, what: moment.utc(dar.date).format("DD.MM. (ddd)"), comment: (dar.dateRestriction || ""), availability: this.findAvailability(dar)}}/>)}
    </tbody>

</table>

{
  (numGood /numTotal > goodRatio) &&
  <div class="modal-dialog" role="document" style={{margin: "1em"}}>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Du bist super!</h5>
        
      </div>
      <div class="modal-body">
      <img src={Awesome1Img} alt="awesome"/>
        <p>
        Danke! So viel grün sieht man gerne!
        </p>
      </div>
      
    </div>
  </div>
}

{
  numBlocked > maxBlockedDates && this.props.workerConfig.displayedUser && this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].status === this.props.workerConfig.webClientConfig.activeTeamMemberStatus
  &&

<div class="modal-dialog" role="document" style={{margin: "1em"}}>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Da ist ziemlich viel rot!</h5>
      </div>
      <div class="modal-body">
        <p>
        {this.props.workerConfig.webClientConfig.tooManyBlockedMessage}
        </p>
      </div>
      <div class="modal-footer">
      <p>Wenn dir das gerade nicht möglich ist, dann melde dich doch persönlich bei deinem Worshipteamleiter. Vielen Dank!</p>
      </div>
    </div>
  </div>
}
</div>


</section>



<section class="py-5">
  <div class="container">
  <a name="settings"><h2 class="font-weight-light">Persönliche Wünsche</h2> </a>
    

<h3 class="font-weight-light" style={{paddingTop: "43px"}}>Häufigkeit</h3> 
<span class="font-weight-light"> Wie oft möchtest du im Zeitraum vom {moment.utc(currentSeason.from).format('DD.MM.')} bis zum {moment.utc(currentSeason.to).format('DD.MM.')} idealerweise eingeteilt werden? </span>
<form>
  <br />
<InputRange
        maxValue={datesOfSeason.length}
        step={1}
        minValue={0}
        allowSameValues={waf.maxNumAvailableDays < datesOfSeason.length}
        formatLabel ={value => `${value}x`}
        value={{min:waf.minNumAvailableDays, max: waf.maxNumAvailableDays}}
        onChange = {value => this.setNewFrequencyRange(waf, value)}
        />
        <br />
</form>
<p>{(waf.minNumAvailableDays === waf.maxNumAvailableDays) ? 
<span>Du möchtest genau {waf.maxNumAvailableDays}x im Einteilungszeitraum eingeteilt werden.</span>
:
<span>Du möchtest zwischen {waf.minNumAvailableDays}x und {waf.maxNumAvailableDays}x im Einteilungszeitraum eingeteilt werden.</span>
}</p>
{
  waf.minNumAvailableDays < Math.floor(minAssignedDates) && this.props.workerConfig.displayedUser
   && this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].status === this.props.workerConfig.webClientConfig.activeTeamMemberStatus
  &&

<div class="modal-dialog" role="document" style={{margin: "1em"}}>
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Das ist ein bisschen wenig</h5>
        
      </div>
      <div class="modal-body">
        <p>
        {format(this.props.workerConfig.webClientConfig.tooLowFrequency,Math.floor(minAssignedDates))}
        </p>
      </div>
      <div class="modal-footer">
      <p>Wenn dir das gerade nicht möglich ist, dann melde dich doch persönlich bei deinem Worshipteamleiter. Vielen Dank!</p>
      </div>
    </div>
  </div>
}

<div class="font-weight-light"  style={{paddingTop: "48px"}}>Um Lücken zu füllen, würden wir dich in seltenen Fällen evtl. zweimal hintereinander einteilen oder einmal öfter als angegeben. Wäre das denkbar?</div>
<table  class="table  autowidth">
    <thead style={{minWidth:"500px"}}>
    <tr>
        <th class="shorty"><span></span></th>
        <th class="shorty"><span>Passt</span></th>
        <th class="shorty"><span>Wenn's sein muss</span></th>
        <th class="shorty"><span>Bitte auf keinen Fall</span></th>        
    </tr>
    </thead>
    <tbody>
    <SurveyRow cols={[true,true,false, true]} onChange={(newData) => this.setConsecutiveAvailability(newData, waf)} data={{id: "consecutive", what: "Zweimal hintereinander eingeteilt", availability: waf.consecutiveAvailability}}/>
    {
      datesOfSeason.length > waf.maxNumAvailableDays && 
    <SurveyRow cols={[true,true,false, true]} onChange={(newData) => this.setOnceTooOftenAvailability(newData, waf)} data={{id: "onceTooOften", what:  (waf.maxNumAvailableDays+1)+"x (also einmal öfter) eingeteilt", availability: waf.onceTooOftenAvailability}}/>
    }
    </tbody>

</table>

{ locationAvailabilities.length > 1 && 
<div>
<h3 class="font-weight-light">Standorte</h3> 
    <table  class="table  autowidth">
    <thead style={{minWidth:"500px"}}>
    <tr>
        <th class="shorty"><span></span></th>
        <th class="shorty"><span>Passt</span></th>
        <th class="shorty"><span>Nicht so gern</span></th>
        <th class="shorty"><span>Nur im Notfall</span></th>
        <th class="shorty"><span>Geht nicht</span></th>        
    </tr>
    </thead>
    <tbody>
    {orderBy(locationAvailabilities,wla=>wla.location).map(wla => 
    <SurveyRow onChange={(newData) => this.setNewLocationAvailability(newData, wla)} data={{what: <span>{wla.location}

{wla.location === "Tour" && 
<ClickAwayListener onClickAway={() => this.handleTourTooltipClose()}>
            
            <Tooltip
              PopperProps={{
                disablePortal: true,
              }}
              onClose={() => this.handleTourTooltipClose()}
              open={this.state.tourTooltipOpen}
              disableFocusListener
              disableHoverListener
              disableTouchListener
              title="Wir stellen einmal im Quartal ein starkes Team komplett aus KA zusammen, das dann den Standort in LB rockt! Wir proben in KA und fahren gemeinsam ins Schwabenland. Ebenso wird es ab Q2/2022 im Standort Rhein-Neckar keine gemischten Teams mehr geben - meist sind Teams komplett aus RN am Start (mit Probe vor Ort), ab und zu aber dann ein Team komplett aus KA (mit Probe in KA, gemeinsame Fahrt)."
            >
              <IconButton style={
      {lineHeight:0.75, padding: '0px', marginLeft: '10px'}
    } 
    onClick={() => this.handleTourTooltipToggle()}><InfoIcon /></IconButton>
            </Tooltip>
        </ClickAwayListener>}
    </span>,
     availability: wla.availability, id: wla.id, workerId: this.props.workerConfig.displayedUser.id}}/>)}
    </tbody>

</table>
</div>
}
{Object.values(this.props.workerConfig.workerRoleAvailabilities).filter(wra => wra.workerId === this.props.workerConfig.displayedUser.id).length > 1 &&
<div>
<h3 class="font-weight-light" style={{paddingTop: "43px"}}>Team-Positionen</h3> 
    <table  class="table  autowidth">
    <thead style={{minWidth:"500px"}}>
    <tr>
        <th class="shorty"><span></span></th>
        <th class="shorty"><span>Passt</span></th>
        <th class="shorty"><span>Nicht so gern</span></th>
        <th class="shorty"><span>Nur im Notfall</span></th>
        <th class="shorty"><span>Geht nicht</span></th>        
    </tr>
    </thead>
    <tbody>
    {orderBy(Object.values(this.props.workerConfig.workerRoleAvailabilities).filter(wra => wra.workerId === this.props.workerConfig.displayedUser.id),wra=>wra.roles.join("+")).map(wra => 
    <SurveyRow onChange={(newData) => this.setNewRoleAvailability(newData, wra)} data={{what: wra.roles.join('+'), availability: wra.availability, id: wra.id, workerId: this.props.workerConfig.displayedUser.id}}/>)}
    </tbody>

</table>
Wie oft möchtest du eingeteilt werden als...
{Object.values(this.props.workerConfig.workerRoleFrequencies).filter(wlf => wlf.workerId === this.props.workerConfig.displayedUser.id)
  .map(wlf => 
  <div style={{display:"flex", paddingTop:"20px"}}>
  <div class="font-weight-light" style={{width:"100px"}} > ...als {wlf.role}:</div>
  <form style={{width:"600px"}}>
  
  <InputRange
          maxValue={Math.min(datesOfSeason.length,waf.maxNumAvailableDays)}
          step={1}
          minValue={0}
          allowSameValues={wlf.maxNumPerSeason < Math.min(datesOfSeason.length,waf.maxNumAvailableDays)}
          formatLabel ={value => `${value}x`}
          value={{min:wlf.minNumPerSeason, max: wlf.maxNumPerSeason}}
          onChange = {value => this.setNewRoleFrequencyRange(wlf, value)}
          />
          <br />
  </form>
  </div>)
  }
  {Object.values(this.props.workerConfig.workerRoleFrequencies).filter(wlf => wlf.workerId === this.props.workerConfig.displayedUser.id)
  .map(wlf => 
  <p>{(wlf.minNumPerSeason === wlf.maxNumPerSeason) ? 
<span>Du möchtest im Einteilungszeitraum  genau {wlf.maxNumPerSeason}x als {wlf.role} eingeteilt werden.</span>
:
<span>Du möchtest im Einteilungszeitraum zwischen {wlf.minNumPerSeason}x und {Math.min(Math.min(wlf.maxNumPerSeason, datesOfSeason.length),waf.maxNumAvailableDays)}x als {wlf.role} eingeteilt werden.</span>
}</p>)
}
  </div>}

<h3 class="font-weight-light"  style={{paddingTop: "43px"}}>Für Paare</h3> 
<span class="font-weight-light"> Möchtest du bevorzugt mit einer anderen Person gemeinsam eingeteilt werden (oder ohne sie)? </span>

<SimpleSelect placeholder="Niemand"
 suggestions={orderBy(Object.values(this.props.workerConfig.workers).map(w => ({label: w.name, value: w.id})), s => s.label)}
 value={workerPairs && workerPairs[0] && (workerPairs[0].worker2Id>=0) && {value:workerPairs[0].worker2Id, label: this.props.workerConfig.workers[workerPairs[0].worker2Id].name}}
 valueChanged={(val) => {this.setWorkerPartner(val && val.value, currentUserId,workerPairs && workerPairs[0] && workerPairs[0].invert, workerPairs && workerPairs[0] && workerPairs[0].weight);}}
 />

 {
   workerPairs && workerPairs[0] && (workerPairs[0].worker2Id>=0) &&
   <FormControlLabel
        control={
          <Checkbox checked={workerPairs && workerPairs[0] && workerPairs[0].invert} value="invertPair" 
          onChange={(val) => {this.setWorkerPartner(workerPairs[0].worker2Id, currentUserId, val.target.checked, workerPairs && workerPairs[0] && workerPairs[0].weight )}}/>
          
        }
        label={"Wir können nicht gemeinsam eingeteilt werden (z.B. wegen Kinderbetreuung)"}
      />
   
 }
 <br />

{is_admin &&  workerPairs && workerPairs[0] && (workerPairs[0].worker2Id>=0) &&
   <FormControlLabel
        control={
          <Checkbox checked={workerPairs && workerPairs[0] && workerPairs[0].weight > 1} value="pairweight" 
          onChange={(val) => {this.setWorkerPartner(workerPairs[0].worker2Id, currentUserId, workerPairs && workerPairs[0] && workerPairs[0].invert, val.target.checked ? 4.0 : 0 )}}/>
          
        }
        label={"Hohe Gewichtung (Admin)"}
      />
   
 }


  </div>
</section>
{is_admin && <section class="py-5">
<div class="container">
<a name="settings"><h2 class="font-weight-light">Administration</h2> </a>

<h3 class="font-weight-light">Häufigkeit nach Standort</h3> 
<span class="font-weight-light"> Wie oft soll {this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].name} im Zeitraum vom {moment.utc(currentSeason.from).format('DD.MM.')} bis zum {moment.utc(currentSeason.to).format('DD.MM.')} eingeteilt werden ... </span>
{Object.values(this.props.workerConfig.workerLocationFrequencies).filter(wlf => wlf.workerId === this.props.workerConfig.displayedUser.id)
.map(wlf => 
<div style={{display:"flex", paddingTop:"20px"}}>
<div class="font-weight-light" style={{width:"100px"}} > ...in {wlf.location}:</div>
<form style={{width:"600px"}}>

<InputRange
        maxValue={datesOfSeason.length}
        step={1}
        minValue={0}
        allowSameValues={true}
        formatLabel ={value => `${value}x`}
        value={{min:wlf.minNumPerSeason, max: wlf.maxNumPerSeason}}
        onChange = {value => this.setNewLocationFrequencyRange(wlf, value)}
        />
        <br />
</form>
</div>)
}

<h3 class="font-weight-light" style={{paddingTop: "43px"}}>Sonderwünsche</h3> 

{false &&
<AceEditor
style={{width:"100%"}}
  mode="json"
  name="jsonEditor"
  onChange={this.onChangeGenericWorkerCost.bind(this)}
  height="250px"
  fontSize="13pt"
  value={this.state.configText || JSON.stringify(this.props.workerConfig.genericWorkerCostDefinitions, null, 2)}
/>
  }
{this.props.workerConfig.genericWorkerCostDefinitions.length === 0 && 
<Button onClick={this.props.actions.makeDefaultCostDefinition} variant="outlined">Sonderwunsch anlegen</Button>
}


  

  <h3 class="font-weight-light" style={{paddingTop: "43px"}}>Erfahrung</h3> 
  <table  class="table  autowidth">
  <thead style={{minWidth:"500px"}}>
  <tr>
      <th class="shorty"><span></span></th>
      <th class="shorty"><span>Pro</span></th>
      <th class="shorty"><span>Normal</span></th>
      <th class="shorty"><span>Einsteiger</span></th>
      <th class="shorty"><span>n/a</span></th>
  </tr>
  </thead>
  <tbody>
{Object.values(this.props.workerConfig.allProperties).map(prop => this.getPropertyExperience(prop))
.map(prop => 
<SurveyRow cols={[true,true,true, true]} onChange={(newData) => this.setNewWorkerProperty(newData)} data={{id: prop.id , what: prop.key, availability: prop.availability}}/>)}

  </tbody>

</table>


</div>
{this.props.workerConfig.loggedInUser.isAdmin
&&
<div class="container">
{previousWorkerId && <Link to={"/worker-config/"+previousWorkerId}><img src={arrowLeft} className="app-logo" alt="previous" /></Link>}
        
<Button onClick={() => {this.setState({avatarLarge: true})}}><Avatar alt={this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].name} src={this.props.workerConfig.workers[this.props.workerConfig.displayedUser.id].avatarThumbUrl} component="div" style={{width: "80px", height: "80px", margin: "0 auto"}}/></Button>
{nextWorkerId && <Link to={"/worker-config/"+nextWorkerId}><img src={arrowRight} className="app-logo" alt="next" /></Link>}
</div>
}

</section>
}

<section class="py-5">
  <div class="container">
  <a name="survey"><h2 class="font-weight-light">Umfrage-Statistik</h2></a>

<SurveyStatistics statistics = {this.props.workerConfig.statistics} />
  </div>
  </section>

<section class="py-5">
  <div class="container">

<a name="about"><h2 class="font-weight-light">Wie wird geplant?</h2></a>
{[this.props.workerConfig.webClientConfig.explanationParagraph1, this.props.workerConfig.webClientConfig.explanationParagraph2].map(par => <p class="font-weight-light">{par}</p>)}
</div>
</section>

{/*params.debug && 
<pre>
                    {JSON.stringify(this.props.workerConfig, null, 4)}
</pre>*/}

<div style={{height: "60px"}} />


</div>}

</div>
  }

</div>

{
  this.props.workerConfig.fetchWorkerDataError
  && 
  <div class="fixed-bottom footer">
  <div class="alert alert-warning" role="alert">
  {getError(this.props.workerConfig.fetchWorkerDataError)}
  </div>
  </div>
}
{
  ((this.props.workerConfig.numChanges && (this.props.workerConfig.numChanges > (this.props.workerConfig.savedChanges === undefined ? 0 : this.props.workerConfig.savedChanges)))
  || (this.props.workerConfig.saveChangesError) || (this.props.workerConfig.saveChangesError) )
  &&
<div class="fixed-bottom footer">
      <Button variant="contained" color="secondary" style={{marginTop: "12px"}} onClick={() => this.props.actions.saveChanges(this.props.workerConfig)} disabled={this.props.workerConfig.saveChangesPending}>
        
        {this.props.workerConfig.saveChangesPending ? <CircularProgress size={24}  /> : <SaveIcon />}&nbsp;
        Änderungen speichern
      </Button>
      {this.props.workerConfig.saveChangesError && <div class="alert alert-warning" role="alert">
      {getError(this.props.workerConfig.saveChangesError)}
      
      </div>
      }

</div>
}


{this.props.workerConfig.loginError && <div class="fixed-bottom footer">
    <div class="alert alert-warning" role="alert">
    {getError(this.props.workerConfig.loginError)}
    </div>
    </div>}
    {this.props.workerConfig.fetchLoggedInUserError && <div class="fixed-bottom footer">
    <div class="alert alert-warning" role="alert">
    {getError(this.props.workerConfig.fetchLoggedInUserError)}
    </div>
    </div>}


</div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    workerConfig: state.workerConfig,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/worker-config/DefaultPage.js